var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6867 5.18065C11.64 5.17398 11.5934 5.17398 11.5467 5.18065C10.5134 5.14732 9.69336 4.30065 9.69336 3.26065C9.69336 2.20065 10.5534 1.33398 11.62 1.33398C12.68 1.33398 13.5467 2.19398 13.5467 3.26065C13.54 4.30065 12.72 5.14732 11.6867 5.18065Z",
    fill: "#000014"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8602 9.80027C13.1136 10.3003 12.0669 10.4869 11.1002 10.3603C11.3536 9.8136 11.4869 9.20694 11.4936 8.56694C11.4936 7.90027 11.3469 7.26694 11.0669 6.7136C12.0536 6.58027 13.1002 6.76694 13.8536 7.26694C14.9069 7.96027 14.9069 9.10027 13.8602 9.80027Z",
    fill: "#000014"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29327 5.18065C4.33994 5.17398 4.38661 5.17398 4.43327 5.18065C5.46661 5.14732 6.28661 4.30065 6.28661 3.26065C6.28661 2.19398 5.42661 1.33398 4.35994 1.33398C3.29994 1.33398 2.43994 2.19398 2.43994 3.26065C2.43994 4.30065 3.25994 5.14732 4.29327 5.18065Z",
    fill: "#000014"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36675 8.56706C4.36675 9.21373 4.50675 9.82706 4.76008 10.3804C3.82008 10.4804 2.84008 10.2804 2.12008 9.80706C1.06674 9.10706 1.06674 7.96706 2.12008 7.26706C2.83341 6.78706 3.84008 6.59373 4.78675 6.70039C4.51341 7.26039 4.36675 7.89373 4.36675 8.56706Z",
    fill: "#000014"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08019 10.58C8.02686 10.5733 7.96686 10.5733 7.90686 10.58C6.68019 10.54 5.7002 9.53333 5.7002 8.29333C5.70686 7.02667 6.72686 6 8.0002 6C9.26686 6 10.2935 7.02667 10.2935 8.29333C10.2869 9.53333 9.31353 10.54 8.08019 10.58Z",
    fill: "#000014"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9132 11.9598C4.90654 12.6331 4.90654 13.7398 5.9132 14.4064C7.05987 15.1731 8.93987 15.1731 10.0865 14.4064C11.0932 13.7331 11.0932 12.6264 10.0865 11.9598C8.94654 11.1931 7.06654 11.1931 5.9132 11.9598Z",
    fill: "#000014"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.39e7ebec5dfd0d9e673b7572e248fc82.svg";
export { ForwardRef as ReactComponent };